import {DamageTypes} from '../enums';

type ResistItem = {
	type: string;
	types?: string[];
	note?: string;
	special?: string;
};

// TODO: типы
export function toMonsterResist(items: ResistItem[]) {
	return items
		.map((item) => {
			if (item.special) return item.special;
			else {
				let result = item.types
					? item.types.map((item) => DamageTypes[item] || item).join(', ')
					: DamageTypes[item.type] || item.type;
				if (item.note) result += ` (${item.note})`;
				return result;
			}
		})
		.sort()
		.join(', ');
}
